import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { setGetGroups } from '../../store/thunk/setGetGroups';
import TemplatePage from '../../../components/templatePage';
import {useStyles} from './helper';
import { useRouter } from '../../../../../@casino/useRouter';

const GroupsCashiers = () => {
    const classes = useStyles();
    const dispatch = useDispatch();
    const router = useRouter();

    React.useEffect(() => {
        dispatch(setGetGroups({
            group: '',
            hide: false
        }))
    }, []);

    const list = useSelector(state => state.cashiersMobile.list);

    return (
        <TemplatePage
            title="Список групп"
        >
            {
                list.map((item) => (
                    <span className={classes.label} onClick={() => router.history.push(`/cashiers/view/${item.id}`)}>
                        {item.groups}
                    </span>   
                ))
            }
        </TemplatePage>
    )
}

export default GroupsCashiers;